import { useParams } from "react-router-dom";
import { useContext } from "react";
import NotFound from "../../common/ErrorPage/NotFound";
import { translate } from "../../../helper";
import LangContext from "../../../contexts/LangContext";
import { ASSET_HOST_BASE_URL } from "../../../config";

import "./index.css";
const filenames = ["Province1.pdf", "Madhesh.pdf", "Bagmati.pdf", "Gandaki.pdf", "Lumbini.pdf", "Karnali.pdf", "SudurPaschim.pdf"];

const CandidateList = (props) => {
  const { lang } = useContext(LangContext);
  const { type } = useParams();

  if (!["fcandidates", "pcandidates"].includes(type)) {
    return <NotFound />;
  }

  return (
    <section className="sh-global-prop-section">
      <div className="container">
        {type !== "pcandidates" ? (
          <div className="card sh-card-summary">
            <div className="col-md-12">
              <h1 className="text-center">{translate("federal", lang) + " " + translate("proportional", lang) + " " + translate("candidates", lang)}</h1>
              <br />
            </div>
            <div className="row">
              <div className="col-md-12">
                <object data={ASSET_HOST_BASE_URL + "/documents/pdf/Pratinidhi_Sabha.pdf#zoom=FitH"} aria-labelledby="file" width="100%" height="500"></object>
              </div>
            </div>
          </div>
        ) : (
          <div className="card sh-card-summary mt-5">
            <div className="col-md-12">
              <h1 className="text-center">{translate("provincial", lang) + " " + translate("proportional", lang) + " " + translate("candidates", lang)}</h1>
              <br />
            </div>
            {props.provinces.map((p, i) => (
              <div className="row mt-4" key={i}>
                <h3 className="text-center">{p["name_" + lang]}</h3>
                <div className="col-md-12">
                  <object data={ASSET_HOST_BASE_URL + "/documents/pdf/" + filenames[i] + "#zoom=FitH"} aria-labelledby="file" width="100%" height="500"></object>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default CandidateList;
